const resetPassword = {
  resetPasswordTitle: 'Redefina sua senha',
  resetNotSuccess: 'Algo correu mal. Por favor, tente novamente, ou entre em contato com michael@moovex.com',
  resetPasswordBtn: 'Prosseguir',
  resetPasswordHint: 'Por favor, digite uma nova senha.',
  resetSuccessful: 'Você alterou sua senha com sucesso.',
  backToLogIn: 'Por favor, volte ao login e entre novamente',
  newPassword: 'Nova senha',
  reEnterPassword: 'Confirme sua senha',
};

export default resetPassword;
